export default __webpack_public_path__ + "static/media/empty-gallery-bg.0d813ec3.svg";